exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".profile-edit .icon-warning{color:orange}", "", {"version":3,"sources":["/home/webuser/tosol/releases/59/spa/src/pages/profile/profileEdit/ProfileEdit.scss"],"names":[],"mappings":"AAGE,4BACE,YAAA,CAAA","file":"ProfileEdit.scss?vue&type=style&index=0&prod&lang=scss&","sourcesContent":["@import '../../../assets/scss/variables';\n\n.profile-edit {\n  .icon-warning {\n    color: orange;\n  }\n}\n"],"sourceRoot":""}]);

// exports
